module.exports = __webpack_public_path__ + "static/media/Icons_25 nov-15.7c4b1bf0.svg";